/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_Import_No_Id_ColumnInputs */



/**
* | output |
* | --- |
* | "No vekn_id or email column found in the header row — at least one is required to match members." |
*
* @param {Csv_Import_No_Id_ColumnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const csv_import_no_id_column = /** @type {((inputs?: Csv_Import_No_Id_ColumnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_Import_No_Id_ColumnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune colonne vekn_id ou email trouvée dans la ligne d'en-tête — au moins une est requise pour associer les membres.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontró ninguna columna vekn_id o email en la fila de encabezado — se requiere al menos una para asociar a los miembros.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhuma coluna vekn_id ou email encontrada na linha de cabeçalho — é necessária pelo menos uma para associar os membros.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna colonna vekn_id o email trovata nella riga di intestazione — ne serve almeno una per associare i membri.")
	return /** @type {LocalizedString} */ ("No vekn_id or email column found in the header row — at least one is required to match members.")
});